import React from 'react'
import { Box, Autocomplete, TextField, Typography, CircularProgress } from '@mui/material'
import { useGetSalesIds } from '../../api/point'

export const SalesFilter = (props) => {
  const { setSalesId, salesId, htgCompany, startDate, endDate, superiorList = [] } = props

  const { data, isLoading } = useGetSalesIds({
    htgCompany,
    startDate,
    endDate,
  })

  const handleSelectItemId = (event, value) => {
    setSalesId(value)
  }

  const filterOption = superiorList.length > 0 ? superiorList : data

  return (
    <Box py={1} mr={2} flex={1}>
      {data?.length || isLoading ? (
        <Box display='flex' flexDirection='row'>
          <Autocomplete
            disablePortal
            id='sales-autocomplete'
            options={filterOption}
            sx={{ maxWidth: 250 }}
            onChange={handleSelectItemId}
            size='small'
            fullWidth
            renderInput={(params) => <TextField {...params} label='Sales Id' />}
            value={salesId}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            disabled={isLoading && superiorList.length === 0}
          />
          {isLoading && superiorList.length === 0 && (
            <Box mr={1}>
              <CircularProgress size='1.5rem' />
            </Box>
          )}
        </Box>
      ) : (
        <Typography>No available sales id</Typography>
      )}
    </Box>
  )
}
